// Too much files to change
/* eslint-disable import/no-internal-modules */
import { Component } from 'preact'
import Button from '../../../../control-components/ui-components/Button'
import ImageUploader from '../../../../control-components/category/ImageUploader'
import classnames from 'classnames'

export interface ImageUploadFieldProps {
  src: string
  onChange: (src: string) => void
}

export default class ImageUploadField extends Component<ImageUploadFieldProps> {
  uploader: HTMLInputElement | null = null

  render() {
    return (
      <div>
        {this.props.src ? (
          <div className='image-upload-field__container'>
            <div className='image-upload-field__image-wrapper'>
              <img src={this.props.src} />
            </div>
            <div className='image-upload-field__buttons'>
              <Button
                type='button'
                className='btn-default btn--insided-secondary-brand'
                onClick={() => this.uploader?.click()}
              >
                Edit
              </Button>
              <Button
                type='button'
                className={classnames('btn-default', 'btn--insided-secondary-brand', 'btn-delete')}
                onClick={() => this.props.onChange('')}
              >
                Remove
              </Button>
            </div>
          </div>
        ) : (
          <div>
            <Button
              type='button'
              className='btn-default btn-primary'
              onClick={() => this.uploader?.click()}
            >
              Upload image
            </Button>
          </div>
        )}
        <ImageUploader
          // eslint-disable-next-line @typescript-eslint/naming-convention
          onUploaded={({ source_thumb }) => {
            return this.props.onChange(source_thumb)
          }}
          uploaderRef={(ref: HTMLInputElement) => {
            this.uploader = ref
          }}
        />
      </div>
    )
  }
}
